import { createBrowserHistory } from 'history'

const hist = createBrowserHistory()

export const history = {
    redirect,
    checkAuth
};

function redirect(path) {
    hist.push(path);
    hist.go();
}

function checkAuth() {
    if(!hist.location.pathname.includes('log_in')){
        hist.push('/log_in');
        hist.go();
    }
}